module.exports = __webpack_public_path__ + "static/media/icon-hamburger-close.1748772b.svg";